import axios from '@/plugins/axios';

/**
 * 获取规则应答明细
 * @param {Number} projectId
 * @param {Number} createId
 */
export function listAnswer(projectId, createId) {
  return axios.get('/bidRuleAnswer/listAnswer', { params: { projectId, createId } });
}
/**
 * 修改规则应答信息
 * @param {Object} params
 */
export function editAnswer(params) {
  return axios.post('/bidRuleAnswer/editAnswer', {
    updateId: params.updateId,
    answerId: params.answerId,
    answerContent: params.answerContent
  });
}

/**
 * 一键应答
 * @param {Number} projectId
 * @param {Number} supplierUserId
 */
export function oneKeyResponse(projectId, supplierUserId) {
  return axios.post('/bidRuleAnswer/oneKeyResponse', { projectId: projectId, supplierUserId: supplierUserId });
}
